__turbopack_context__.v({
  "className": "gfsdidot_e581bbe5-module__CwTIuW__className",
  "variable": "gfsdidot_e581bbe5-module__CwTIuW__variable",
});
